import React from "react";
import { Container } from "@mui/material";
import { AuthState } from "context/AuthContext";
import { custom } from "data/authData";
import { allowAccess } from "utils/userAccessFun";
import SalesOrderAlerts from "./SalesOrderAlerts";
import SalesOrderWeeklyReport from "./SalesOrderWeeklyReport";

const Dashboard = () => {
	const { user } = AuthState();
	const canViewWeeklyReport =
		user && allowAccess(custom.SORA_WEEKLY_REPORT.key, user);

	return (
		<Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, md: 4 }, py: { xs: 4, sm: 6, md: 8 } }}>
			<SalesOrderAlerts />
			{canViewWeeklyReport && <SalesOrderWeeklyReport />}
		</Container>
	);
};

export default Dashboard;
